import {
  useApiV2CustomerExperiments,
  type Props as UseGetCustomerExperimentsProps,
} from '../api/use-api-v2-get-customer-experiments';
import { type Experiments } from '../experiments';
import { getExperimentGroup } from '../query/get-experiment-group';

export function usePostSignupExperiments<T extends Experiments>(
  expId: T,
  apiProps: UseGetCustomerExperimentsProps
) {
  const { data: authenticatedUserExperiments } =
    useApiV2CustomerExperiments(apiProps);

  if (authenticatedUserExperiments === undefined) {
    return undefined;
  }

  return getExperimentGroup(expId, authenticatedUserExperiments);
}
